// extracted by mini-css-extract-plugin
module.exports = {"container":"Principal_container__17tau","article":"Principal_article__2a_gX","title":"Principal_title__15jSv","trade":"Principal_trade__1tTo7","pics":"Principal_pics__1okEI"};